




































import { Vue, Component } from 'vue-property-decorator'
import { Button } from 'mand-mobile'
import store from '@/store'

@Component({ components: { [Button.name]: Button } })
export default class Result extends Vue {
  get isSuccess() {
    if (this.$route.query.result === 'SUCCESS') {
      return true
    } else {
      return false
    }
  }
  get score() {
    if (this.$route.query.result === 'SUCCESS') {
      return this.$route.query.score
    } else {
      return ''
    }
  }
  get message() {
    if (this.$route.query.result === 'IAM_FAILED') {
      return this.$t(`result.tokenExpired`)
    } else {
      return this.$route.query.message
    }
  }
  get returnUrl() {
    return this.$route.query.returnUrl
  }
  restartHandler() {
    console.log('jiji', store.bizToken)
    window.location.href = `/?biz_token=${store.bizToken}`
    // this.$router.push({ name: 'homeV2', query: {
    //   biz_token: store.bizToken
    // }})
  }
  nextStep() {
    window.location.href = `${this.returnUrl}`
  }
}
